import { client } from '../../..'
import { ChangeInput, CreateOrUpdateChangeMutation, CreateOrUpdateChangeMutationVariables, Country } from '../../../types'
import ChangeQueriesAndMutations from '../ChangeQueriesAndMutations'
import { GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION } from '../../contract/ContractQueries'
import { FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING } from '../../../modules/appraisal/appraisal-flow/shared/appraisal-components/Queries'
import { GraphQLFormattedError } from 'graphql'

const mutateCreateOrUpdateChange = (
  changeInput: ChangeInput,
  employeeId: number,
  year: number,
  withChanges: boolean,
  includeAllTargetBoni: boolean,
  country: Country,
  meetingId: number,
) => {
  return client.mutate<CreateOrUpdateChangeMutation, CreateOrUpdateChangeMutationVariables>({
    mutation: ChangeQueriesAndMutations.CreateOrUpdateChange,
    variables: {
      change: changeInput,
      employeeId: employeeId,
    },
    refetchQueries: [
      {
        query: ChangeQueriesAndMutations.OpenContractChanges,
        variables: {
          id: employeeId,
        },
      },
      {
        query: GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION,
        variables: {
          employeeId: employeeId,
          year: year,
          withChanges: withChanges,
          includeAllTargetBoni: includeAllTargetBoni,
          country,
        },
      },
      {
        query: FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING,
        variables: {
          employeeId,
          meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export default (
  employeeId: number,
  country: Country,
): {
  createOrUpdateChange: (
    changeInput: ChangeInput,
    year: number,
    withChange: boolean,
    includeAllTargetBoni: boolean,
    meetingId: number,
  ) => Promise<{
    data: CreateOrUpdateChangeMutation | null | undefined
    errors: readonly GraphQLFormattedError<Record<string, unknown>>[] | undefined
  }>
} => {
  const createOrUpdateChange = async (
    changeInput: ChangeInput,
    year: number,
    withChange: boolean,
    includeAllTargetBoni: boolean,
    meetingId: number,
  ): Promise<{
    data: CreateOrUpdateChangeMutation | null | undefined
    errors: readonly GraphQLFormattedError<Record<string, unknown>>[] | undefined
  }> => {
    const { data, errors } = await mutateCreateOrUpdateChange(
      changeInput,
      employeeId,
      year,
      withChange,
      includeAllTargetBoni,
      country,
      meetingId,
    )
    return { data, errors }
  }

  return {
    createOrUpdateChange,
  }
}
